import { ResultCode } from '@afterpaytouch/topaz-api'
import { TopazStatus, topazResultCodeErrors } from '../model'

export interface TopazLogProperties {
  type: string
  topazStatus?: string
  topazResultCode?: ResultCode | string
  context?: string
  errorCode?: string
  errorMessage?: string
}

export interface ParseTopazLogPropertiesRequest {
  resultCode?: ResultCode | string
  topazStatus?: string
  context?: string
  type?: string
  errorCode?: string
  errorMessage?: string
}
export const parseTopazLogEventProperties = ({
  resultCode,
  topazStatus,
  context,
  type = 'handledException',
  errorCode,
  errorMessage,
}: ParseTopazLogPropertiesRequest): TopazLogProperties => {
  if (typeof resultCode !== 'undefined' && typeof topazStatus === 'undefined') {
    const topazResultCodeMappingStatus = topazResultCodeErrors[resultCode]
    return {
      type,
      topazStatus: topazResultCodeMappingStatus ? TopazStatus[topazResultCodeMappingStatus] : TopazStatus[TopazStatus.Error],
      topazResultCode: resultCode,
      context,
      errorMessage,
      errorCode,
    }
  } else if (typeof topazStatus !== 'undefined') {
    return {
      type,
      topazStatus: topazStatus.toString(),
      topazResultCode: resultCode,
      context,
      errorMessage,
      errorCode,
    }
  } else {
    return {
      type: 'exception',
      errorCode,
      context,
      topazStatus,
      errorMessage,
    }
  }
}
